




































































import Vue from 'vue'

export default Vue.extend({
  name: 'App',

  components: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    toggleThemeIcon: function () {
      return this.$vuetify.theme.dark
        ? 'mdi-weather-night' // moon-waxing-crescent
        : 'mdi-white-balance-sunny'
    }
  },

  methods: {
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  }
})
